import {Close} from '@material-ui/icons';

export default function Confirmation({onClose, onSubmit, text}) {
  return (
    <div className='modal_content center confirmation'>
      <div className='modal_body'>
        <p className='confirmation_title'>{text}</p>
        <div className='confirmation_button'>
          <button
            className='confirmation_button_cancel'
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </button>
          <button
            className='confirmation_button_confirm'
            onClick={() => {
              onSubmit();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
